/* ─── Base ─── */

.root {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  position: relative;
  box-sizing: border-box;
  border: none;
  font-family: var(--font-sans);
  font-weight: 700;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: box-shadow var(--motion-duration-short3)
      var(--motion-easing-standard),
    opacity var(--motion-duration-short3) var(--motion-easing-standard);
}

/* ─── State layer ─── */

.root::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .root:hover::before {
    opacity: var(--state-hover);
  }
}

.root:focus-visible::before {
  opacity: var(--state-focus);
}

.root:active::before {
  opacity: var(--state-pressed);
}

/* ─── Disabled ─── */

.root:disabled {
  cursor: not-allowed;
  opacity: 0.38;
  box-shadow: none;
}

.root:disabled::before {
  display: none;
}

/* ─── Size variants ─── */

.sm {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: var(--shape-md);
  box-shadow: var(--elevation-3);
}

.md {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: var(--shape-lg);
  box-shadow: var(--elevation-3);
}

.lg {
  width: 6rem;
  height: 6rem;
  border-radius: var(--shape-xl);
  box-shadow: var(--elevation-3);
}

.extended {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  height: 3rem;
  padding-inline: var(--space-6);
  border-radius: var(--shape-lg);
  box-shadow: var(--elevation-3);
}

/* ─── Hover elevation ─── */

@media (hover: hover) {
  .root:hover:not(:disabled) {
    box-shadow: var(--elevation-4);
  }
}

/* ─── Color variants ─── */

.color-primary-container {
  background: var(--md-primary-container);
  color: var(--md-primary);
}

.color-surface {
  background: var(--md-surface-container-high);
  color: var(--md-primary);
}

.color-secondary-container {
  background: var(--md-secondary-container);
  color: var(--md-on-secondary-container);
}

.color-tertiary-container {
  background: var(--md-tertiary-container);
  color: var(--md-on-tertiary-container);
}

/* ─── Icon ─── */

.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon svg {
  width: 1em;
  height: 1em;
}

.sm .icon {
  font-size: var(--icon-size-md);
}

.md .icon {
  font-size: var(--icon-size-lg);
}

.lg .icon {
  font-size: var(--icon-size-xl);
}

.extended .icon {
  font-size: var(--icon-size-lg);
}

/* ─── Label (extended only) ─── */

.label {
  white-space: nowrap;
}
